import { lazy, Suspense } from 'react'
import { createBrowserRouter } from 'react-router-dom'
import { Spinner } from '@shared/ui'
import { PendingRiskAgreementProvider } from '@app/providers/PendingRiskAgreementProvider'
import { PcLayout } from '@widgets/pc-layout'
import { AuthGuard, GuestGuard, SvrGuard } from './guards'

const w = (Page: React.ComponentType) => (
  <Suspense fallback={<Spinner size="lg" fullscreen />}>
    <Page />
  </Suspense>
)

const NotFoundPage = lazy(() => import('@pages/not-found'))
const WsTestPage = lazy(() => import('@pages/ws-test'))

const PcMainPage = lazy(() => import('@pages/pc/main'))
const PcMarketPage = lazy(() => import('@pages/pc/market'))
const PcLoginPage = lazy(() => import('@pages/pc/login'))
const PcSignupPage = lazy(() => import('@pages/pc/signup'))
const PcTermsPage = lazy(() => import('@pages/pc/terms'))
const PcForgotPasswordPage = lazy(() => import('@pages/pc/forgot-password'))
const PcAccountPage = lazy(() => import('@pages/pc/account'))
const PcPasswordPage = lazy(() => import('@pages/pc/password'))
const PcDeleteUserPage = lazy(() => import('@pages/pc/delete-user'))
const PcPnlPage = lazy(() => import('@pages/pc/pnl'))
const PcNotificationsPage = lazy(() => import('@pages/pc/notifications'))
const PcTradePage = lazy(() => import('@pages/pc/trade'))

export const pcRouter = createBrowserRouter([
  // 모든 라우트는 PcLayout으로 감쌈
  {
    element: (
      <PendingRiskAgreementProvider>
        <PcLayout />
      </PendingRiskAgreementProvider>
    ),
    children: [
      { path: '/', element: w(PcMainPage) },
      { path: '/terms', element: w(PcTermsPage) },
      { path: '/ws-test', element: w(WsTestPage) },
      // 비로그인 전용 (로그인 상태면 홈으로)
      {
        element: <GuestGuard />,
        children: [
          { path: '/login', element: w(PcLoginPage) },
          { path: '/signup', element: w(PcSignupPage) },
          { path: '/forgot-password', element: w(PcForgotPasswordPage) },
        ],
      },
      // 로그인 필수 — 어카운트 등록 페이지(svrId 없이 진입 가능)
      {
        element: <AuthGuard />,
        children: [
          { path: '/account', element: w(PcAccountPage) },
          { path: '/password', element: w(PcPasswordPage) },
          { path: '/delete-user', element: w(PcDeleteUserPage) },
        ],
      },
      // 로그인 + svrId(어카운트) 필수 — 미입력 시 /account로 리다이렉트
      {
        element: <SvrGuard redirectTo="/account" />,
        children: [
          { path: '/market', element: w(PcMarketPage) },
          { path: '/pnl', element: w(PcPnlPage) },
          { path: '/notifications', element: w(PcNotificationsPage) },
          { path: '/trade', element: w(PcTradePage) },
        ],
      },
      { path: '*', element: w(NotFoundPage) },
    ],
  },
])
